import EmailInput from "./EmailInput";
import PasswordInput from "./PasswordInput";
import * as Const from "../Const";
import React, {useContext, useState} from "react";
import axios from "axios";
import {SessionContext} from "../context/SessionContextProvider";
import {useNavigate} from "react-router-dom";
import {Card} from "react-bootstrap";






function UserLoginTab() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
    const [errorString, setErrorString] = useState(null);

    const { updateSession } = useContext(SessionContext);

    const navigation = useNavigate();


    function handleEmailChange(value) {
        setEmail(value);
        setIsSubmitDisabled(false);
    }

    function handlePasswordChange(value) {
        setPassword(value);
        setIsSubmitDisabled(false);
    }



    function handleSubmit(event) {
        event.preventDefault();

        setIsSubmitDisabled(true);
        setErrorString(null);

        const data = {
            "username": email,
            "password": password,
        };

        axios.post(Const.API_CLOUD_USERS_AUTH, data, { withCredentials: true })
            .then(res => {
                console.log("login result: ", JSON.stringify(res));
                if (res['headers']) {
                    updateSession( res['headers']['authorization']);
                } else {
                    updateSession(null);
                }

                if (res.status === 204) {
                    axios.get(Const.API_CLOUD_USERS_AUTH,{withCredentials: true}).then(res => {
                        // console.log("session:", res);
                        // TODO FIXME remove
                        if (res.data.user_id === 34) {
                            navigation(Const.BASE_NAME + "/rain");
                        }
                    }).catch(error => {
                        console.log("session error", JSON.stringify(error));
                    })

                    navigation(Const.BASE_NAME + "/map");
                    // navigation(Const.BASE_NAME + "/user/home");
                }
            })
            .catch(error => {
                console.log(JSON.stringify(error));
                setErrorString(JSON.stringify(error));
                const res = error.response;
                if (res && res.status && res.status === 409) {
                    navigation(Const.BASE_NAME + "/user/confirm");
                } else {
                    navigation(Const.BASE_NAME + "/user/login");
                }
                setIsSubmitDisabled(false);
                updateSession(null);
            });
    }

    return (
        <Card>
            <Card.Header>
                Log in
            </Card.Header>
            <Card.Body>
                <form className="row g-3 align-items-start" method={"post"}>
                    <div className={"col-12 col-lg-5"}>
                        <EmailInput email={email} onChange={handleEmailChange} isValid={undefined} />
                    </div>
                    <div className={"col-12 col-lg-5"}>
                        <PasswordInput name={"password"} placeholder={"Password"} onChange={handlePasswordChange} isValid={undefined} />
                    </div>
                    <div className={"col-12 col-lg-2"}>
                        <button className={"btn btn-primary w-100"} type={"submit"} onClick={handleSubmit} disabled={isSubmitDisabled}>Log in</button>
                    </div>
                </form>
            </Card.Body>

            {errorString ? <div className={"card-body"}>{errorString}</div> : null}

            <Card.Footer>
                <div className={"row justify-content-center"}>
                    <div className={"col-12 col-lg-4"}>
                        <a className={"btn btn-outline-secondary w-100"} href={Const.BASE_NAME + "/user/new"}>Create New Account</a>
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );
}


export default UserLoginTab;
